
import { InputNewCounter } from "../../../../../components/InputNewCounter/InputNewCounter";
import { ProgressBar } from "../../../../../components/ProgressBar/ProgressBar";
import { Label } from "../../../../../components/texts/label";
import { Text } from "../../../../../components/texts/text";
import { _colorText, _size, _sizeText, _typeLabel } from "../../../../../core/core";
import { useOrder } from '../../../../../entities/order/context/OrderContext';
import './CountChanger.css';

interface CountChangerProps {
    defaultCount: number;
    steps?: number[];
    price_min?: number;
    price_max?: number;
    handleChangePrice?: (price: number) => void;
}

export const CountChanger = (
    { steps = [1, 5, 15, 20, 25], price_min = 250, price_max = 100, handleChangePrice }: CountChangerProps
) => {
    const { form, price } = useOrder();

    return (
        <div className="count-changer-main">
            <div className="count-changer-top">
                <div className="count-changer-top__left">
                    <div className="count-changer-top__left-price">
                        <Text size={_sizeText.mbold} >Стоимость</Text>
                        <Text size={_sizeText.mbold} >{price.currentPrice} ₽/шт</Text>
                        <div className="count-changer-old-price-block">
                            <Text size={_sizeText.m} color={_colorText.neutral}>{price_max} ₽</Text>
                            <span className="count-changer-old-price-line" />
                        </div>
                    </div>
                    {price.nextStep ? (
                        <Text size={_sizeText.m} color={_colorText.neutral}>
                            Еще {price.leftToNext} шт, и будет {price.nextPrice}₽/шт
                        </Text>
                    ) : (
                        <Text size={_sizeText.m} color={_colorText.neutral}>
                            Лучшая цена - это всегда приятно
                        </Text>

                    )}

                </div>
                <div className="count-changer-top__right">
                    <InputNewCounter
                        color={'inverse'}
                        min={price.minCount}
                        max={price.maxCount}
                        value={form.count}
                        onChangeValue={form.setCount}

                    />
                </div>
            </div>
            <div className="count-changer-steps">
                <div className="count-changer-steps-labels">
                    {steps.map((step, idx) => {
                        let stepProgress = 0;

                        if (idx === 0) {
                            // Первый шаг: от 1 до 5 штук
                            if (form.count >= step) {
                                stepProgress = Math.min(100, ((form.count - step) / (steps[idx + 1] - step)) * 100);
                            }
                        } else if (idx < steps.length - 1) {
                            // Средние шаги: от текущего до следующего
                            const currentStep = step;
                            const nextStep = steps[idx + 1];

                            if (form.count >= currentStep) {
                                if (form.count >= nextStep) {
                                    stepProgress = 100; // Шаг полностью пройден
                                } else {
                                    stepProgress = ((form.count - currentStep) / (nextStep - currentStep)) * 100;
                                }
                            }
                        } else {
                            // Последний шаг: от последнего до максимума
                            if (form.count >= step) {
                                stepProgress = 100;
                            }
                        }
                        const priceStep = price.prices[idx];
                        return (
                            <div key={step} className={`count-changer-steps-prices ${idx === steps.length - 1 ? 'last-step' : ''}`}>
                                <div className={`count-step-fixed ${idx !== 0 && idx !== steps.length - 1 ? 'count-step-fixed-offset' : ''}`}>
                                    <Text key={step} size={_sizeText.s} style={{ width: `52px` }} color={_colorText.neutral}>{idx === 0 ? `${step} шт` : `от ${step} шт`}</Text>
                                </div>
                                <div key={step} style={{ paddingRight: '10px' }} className="count-step-fixed">
                                    {idx !== steps.length - 1 && (
                                        <ProgressBar
                                            progress={stepProgress}
                                            width={"100%"}
                                        />
                                    )}
                                </div>
                                <div className={`count-step-fixed ${idx !== 0 && idx !== steps.length - 1 ? 'count-step-fixed-offset' : ''}`}>
                                    <Label key={priceStep} type={idx === price.activeStep ? _typeLabel.primary : _typeLabel.secondary} size={_size.XS} style={{ width: `40px` }}>{priceStep}₽</Label>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="count-changer-mob">
                <InputNewCounter
                    color={'inverse'}
                    min={price.minCount}
                    max={price.maxCount}
                    value={form.count}
                    onChangeValue={form.setCount}
                />
            </div>
        </div>
    );
}